export default __webpack_public_path__ + "static/media/key-icon.6f1b7ea7.svg";